module.exports = __webpack_public_path__ + "img/7ca3293606b632d7124ca3d168689fb4.cfddffa3.jpg";